import React, { useState, useEffect } from 'react';
import {
  Container, Header, Table, Button, Link, StatusIndicator, Box, SpaceBetween
} from '@cloudscape-design/components';
import { productImageGenApi } from './productImageGenApi.js';

export default function JobHistory({ refreshTrigger }) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadJobs = async () => {
    setLoading(true);
    try { const data = await productImageGenApi.listJobs(); setJobs(data.jobs || []); }
    catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadJobs(); }, [refreshTrigger]);

  const formatTime = (iso) => {
    if (!iso) return '-';
    const d = new Date(iso);
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
      + ' ' + d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <Container header={
      <Header variant="h2" actions={<Button iconName="refresh" onClick={loadJobs} loading={loading}>Refresh</Button>}>
        Generation History
      </Header>
    }>
      <Table
        columnDefinitions={[
          { id: 'time', header: 'Time', cell: (item) => formatTime(item.timestamp), width: 160 },
          { id: 'user', header: 'User', cell: (item) => item.user || '-', width: 100 },
          { id: 'brand', header: 'Brand', cell: (item) => item.brand_name || '-', width: 140 },
          { id: 'category', header: 'Category', cell: (item) => item.category || '-', width: 160 },
          { id: 'products', header: 'Products', cell: (item) => item.total_products || 0, width: 80 },
          { id: 'generated', header: 'Images', cell: (item) => (
            <StatusIndicator type="success">{item.total_generated || 0} generated</StatusIndicator>
          ), width: 140 },
          { id: 'sample', header: 'Sample', cell: (item) => item.sample_url
            ? <Link href={item.sample_url} external fontSize="body-s">Preview</Link> : '—', width: 80 },
        ]}
        items={jobs} loading={loading} loadingText="Loading..."
        variant="embedded" sortingDisabled
        empty={
          <Box textAlign="center" padding="l">
            <SpaceBetween size="xxs">
              <Box variant="p"><b>No generations yet</b></Box>
              <Box variant="p" color="text-body-secondary">Generate images to see history here.</Box>
            </SpaceBetween>
          </Box>
        }
      />
    </Container>
  );
}
